import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'query-string';
import { resetPassword } from '../../actions/sessions';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import MemberService from '../../services/memberService';
import CONSTANTS from '../../constants'

class ResetPassword extends Component {

    constructor(props) {
        MemberService.logout();
        super(props);
        this.state = {
            bname: this.props.match.params.bname,
            reset_password_token: '',
            new_password: '',
            password_confirmation: ''
        };
    }

    renderField(field) {
        let hasError = field.meta.touched && field.meta.error;
        return (
            <div className="form-group">
                <div className="input-group">
                    <span className="input-group-addon is-invalid"><i className={field.icon}></i></span>
                    <input {...field.input}  className={`form-control ${hasError ? 'is-invalid' : ''}`} type={field.type}
                           placeholder={field.placeholder} value={field.value} />
                </div>
                <div className="invalid-feedback">
                    { hasError ? field.meta.error : ''}
                </div>
            </div>
        )
    }

    onSubmit(values) {
        const email = qs.parse(this.props.location.search).email;
        this.props.resetPassword(this.state.bname, email, values.reset_password_token, values.new_password,
            values.password_confirmation, this.props.history);
    }

    render () {
        const { handleSubmit } = this.props;
        return (
            <div className="flex-center">
                <div className="content-card col-lg-6 col-xs-12">
                    <h1>{CONSTANTS.APP_TITLE}</h1>
                    <p className="text-muted">Reset password</p>
                    <form className="members-area-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                        <Field
                            name="reset_password_token"
                            type="text"
                            placeholder="Reset password token"
                            className="form-control"
                            icon="fas fa-unlock-alt"
                            value={this.state.reset_password_token}
                            component={this.renderField}
                        />

                        <Field
                            name="new_password"
                            type="password"
                            placeholder="New password"
                            className="form-control"
                            icon="fas fa-key"
                            value={this.state.new_password}
                            component={this.renderField}
                        />

                        <Field
                            name="password_confirmation"
                            type="password"
                            placeholder="Password confirmation"
                            className="form-control"
                            icon="fas fa-key"
                            value={this.state.password_confirmation}
                            component={this.renderField}
                        />

                        <button type="submit" className="btn btn-lg btn-primary full-width">Reset password</button>
                    </form>
                    <div className="text-center small mt-10">
                        <span className="text-muted">Already have a login? &nbsp;</span>
                        <Link to={`/${this.state.bname}/login`}>Login here</Link>
                    </div>
                </div>
            </div>
        );
    }
}

function validate(values) {
    let errors = {};

    if(!values.reset_password_token)
        errors.reset_password_token = 'Please enter reset password token here';
    if(!values.new_password)
        errors.new_password = 'Please enter new password here';
    if(!values.password_confirmation)
        errors.password_confirmation = 'Please confirm your new password here';
    if(values.new_password !== values.password_confirmation)
        errors.password_confirmation = 'Passwords do not match';
    return errors;
}

export default reduxForm({validate: validate, form: 'forgotPasswordForm'})(connect(null, { resetPassword })(ResetPassword));
